"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "pop-set-realname",
  components: {},
  props: {},
  data: function data() {
    return {
      isShow: false,
      resolve: null,
      reject: null,
      formData: {
        uid: "",
        realName: "",
        isPromoter: false,
        status: false
      },
      rules: {
        realName: [{
          required: true,
          message: "请输入用户真实姓名",
          trigger: "blur"
        }]
      }
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.resolve = null;
    this.reject = null;
  },
  watch: {},
  methods: {
    clearForm: function clearForm() {
      this.formData.realName = "";
      this.formData.isPromoter = false;
      this.formData.status = false;
    },
    // 打开弹窗
    openPop: function openPop(data) {
      var _this = this;
      this.isShow = true;
      this.clearForm();
      this.formData.uid = data.uid;
      this.getUserInfo();
      return new Promise(function (re, rj) {
        _this.resolve = re;
        _this.reject = rj;
      });
    },
    // 获取用户详情
    getUserInfo: function getUserInfo() {
      var _this2 = this;
      (0, _user.userInfoApi)({
        id: this.formData.uid
      }).then(function (res) {
        if (res) {
          _this2.formData.realName = res.realName || "";
          _this2.formData.isPromoter = res.isPromoter || false;
          _this2.formData.status = res.status || false;
        }
      });
    },
    // 关闭弹窗
    closePop: function closePop() {
      this.isShow = false;
      this.resolve([false, null]);
    },
    // 保存
    onSubmit: function onSubmit() {
      var _this3 = this;
      this.$refs['用户真实姓名设置表单'].validate(function (valid) {
        if (!valid) return;
        (0, _user.userUpdateApi)({
          id: _this3.formData.uid
        }, _this3.formData).then(function (res) {
          _this3.isShow = false;
          _this3.resolve([true, _this3.formData.realName]);
        });
      });
    }
  }
};